"use strict";
exports.__esModule = true;
exports.getChartOptions = void 0;
var WaterfallLegends = [
    { type: 'scatter', name: 'Increase', color: '#86c166', marker: { symbol: 'square' }, data: [], showInLegend: true },
    { type: 'scatter', name: 'Decrease', color: '#f05b72', marker: { symbol: 'square' }, data: [], showInLegend: true },
];
function getChartOptions(graph, options) {
    var settings = options.settings, timestamp = options.timestamp;
    var seriesData = graph.isCompareTo ? graph.differenceRows : graph.mainRows;
    var series = [{
            type: 'waterfall',
            name: graph.yTitle,
            data: seriesData.map(function (row) { return ({ name: row.label, y: row.value, color: row.color, isSum: row.isSum == true }); }),
            showInLegend: false
        }];
    series = series.concat(WaterfallLegends);
    return {
        chart: {
            renderTo: 'chartContainer',
            height: 500,
            width: 750,
            type: 'waterfall',
            zoomType: 'xy',
            marginRight: 50
        },
        credits: {
            text: timestamp,
            href: null
        },
        plotOptions: {
            series: {
                events: {
                    legendItemClick: function (e) {
                        e.preventDefault();
                    }
                }
            }
        },
        legend: {
            enabled: true,
            itemStyle: {
                color: '#000000',
                cursor: 'default'
            },
            itemHoverStyle: {
                color: '#000000',
                cursor: 'default'
            }
        },
        title: {
            text: graph.chartTitle
        },
        tooltip: {
            enabled: settings.showTooltip,
            formatter: function () {
                if (settings.decimals == "Default") {
                    return "<b>" + this.point.name + "</b> <br /><b>" + this.point.y + " " + graph.Units + "</b>";
                }
                else {
                    return "<b>" + this.point.name + "</b> <br />" +
                        ("<b>" + this.point.y.toFixed(settings.decimals) + " " + graph.Units + "</b>");
                }
            }
        },
        xAxis: {
            type: 'category'
        },
        yAxis: {
            title: {
                enabled: true,
                text: graph.yTitle
            }
        },
        series: series
    };
}
exports.getChartOptions = getChartOptions;
//# sourceMappingURL=waterfall.chart.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/waterfall2/waterfall.chart.js